import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* tenantsList(action) {
    const url = api.buildTenantsListUrl();
    const authGet = yield authenticatedRequest(FetchService.get);
    const {response, data} = yield call(authGet, {
        url: url,
    });
    const error = response.status !== 200;
    yield put(actions.tenantsListResponse({ payload: {data: data}, error: error }));
}

function* watchTenantsList() {
    yield takeLatest(ty.TENANTS_LIST_REQUEST, errorSafeSaga(tenantsList));
}

function* tenantDelete(action) {
    const url = api.buildTenantDeleteUrl({ tenant_id: action.payload.params.tenant_id });
    const authDel = yield authenticatedRequest(FetchService.delete);
    const {response, data} = yield call(authDel, {
        url: url,
    });
    const error = response.status !== 200;
    yield put(actions.tenantDeleteResponse({ payload: {data: data}, error: error }));
    yield put(actions.tenantsListRequest());
}

function* watchTenantDelete() {
    yield takeLatest(ty.TENANT_DELETE_REQUEST, errorSafeSaga(tenantDelete));
}

function* tenantCreate(action) {
    const url = api.buildTenantCreateUrl();
    const authPost = yield authenticatedRequest(FetchService.post);
    console.log("action.payload.params", action.payload.params);
    console.log("action.payload.params.tenant", action.payload.params.tenant);
    const {response, data} = yield call(authPost, {
        url: url,
        params: action.payload.params.tenant
    });
    const error = response.status !== 200;
    yield put(actions.tenantCreateResponse({ payload: {data: data}, error: error }));
    yield put(actions.tenantsListRequest());
}

function* watchTenantCreate() {
    yield takeLatest(ty.TENANT_CREATE_REQUEST, errorSafeSaga(tenantCreate));
}

function* tenantUpdate(action) {
    const url = api.buildTenantUpdateUrl({ tenant_id: action.payload.params.tenant_id });
    const authPut = yield authenticatedRequest(FetchService.put);
    const {response, data} = yield call(authPut, {
        url: url,
        params: action.payload.params.tenant
    });
    const error = response.status !== 200;
    yield put(actions.tenantUpdateResponse({ payload: {data: data}, error: error }));
    yield put(actions.tenantsListRequest());
}

function* watchTenantUpdate() {
    yield takeLatest(ty.TENANT_UPDATE_REQUEST, errorSafeSaga(tenantUpdate));
}


function* saga() {
  yield all([
    fork(watchTenantsList),
    fork(watchTenantDelete),
    fork(watchTenantCreate),
    fork(watchTenantUpdate),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/tenants/saga.js